import { useState, useEffect } from 'react';
import { WorkerProject, WorkerApiResponse } from '../types/worker.types';
import { workerService } from '../services/worker.service';

interface UseWorkerProjectResult {
  project: WorkerProject | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useWorkerProject(token: string): UseWorkerProjectResult {
  const [project, setProject] = useState<WorkerProject | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProject = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response: WorkerApiResponse<WorkerProject> = await workerService.validateToken(token);
      
      if (response.error) {
        setError(response.error.message);
        setProject(null);
      } else {
        setProject(response.data);
      }
    } catch (err) {
      setError('Erreur lors du chargement du projet');
      setProject(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchProject();
    }
  }, [token]);

  const refetch = async () => {
    await fetchProject();
  };

  return {
    project,
    loading,
    error,
    refetch
  };
}